module.exports = __webpack_public_path__ + "img/google-1088004_640.8af67520.png";